import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import CardSimple from 'screens/components/basic/CardSimple';
import Body from './Body';
import Header from './Header';
import { getYearlyProfitReport, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Pagination from 'screens/components/basic/Pagination';
import Button from 'screens/components/basic/Button';
import Grid from 'screens/components/basic/Grid';
import { reportYearlyProfitReport } from 'utils/breadcrumbInfo';
import WithRouter from 'custom/withRouter';

class YearlyProfitReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0,
            model: {
                beginDate: 0,
                endDate: 0,
                branch: 0
            }
        };

        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date()
        this.props.formInput(date.getFullYear(), `YearlyProfitReportYear`);

        // this.cleanSearch();
        this.filter();
    }

    cleanSearch = () => {
        this.props.clearFormInput(`YearlyProfitReportYear`);
        this.props.clearFormInput(`YearlyProfitReportBranchOption`);

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    showBody() {

        this.filter();
        this.setState({ showBody: true });
    }


    getReport = () => {
        let year = this.props.year || moment().format('YYYY');
        let branch = this.props.branch || this.props.loggedBranch;

        this.props.getYearlyProfitReport({ year, branch });

    }

    downloadReport = () => {
        let year = this.props.year || moment().format('YYYY');
        let branch = this.props.branch || this.props.loggedBranch;
        this.props.getCsvReport(`reports/excel/YearlyProfit?year=${year}&branch=${branch}`, "YearlyProfit");

    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    componentWillReceiveProps = (newProps) => {
        if (this.state.showBody) {
            const totalRow = newProps.yearlyProfitReport.months.length > 0 ? newProps.yearlyProfitReport.months[0].totalRows : 0;
            this.setState({ totalRow: totalRow })
        }
    }

    render() {
        // let viewModel = this.getTaxViewModel();
        const totalRow = this.props.yearlyProfitReport.length > 0 ? this.props.yearlyProfitReport[0].totalRows : 0;

        return (
            <Grid headerContent={reportYearlyProfitReport}>
                <div className="bg-light-opacity">
                    <div className="row m-0 pa-2">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <h2>{LOOKUP.report.yearlyProfitReport.text} </h2>
                            <h5>{LOOKUP.report.yearlyProfitReport.description}</h5>
                        </div>
                    </div>
                    <div className="pa-2">
                        <Header
                            loggedBranch={this.props.loggedBranch} branchOptions={this.props.brachOptions} filter={this.filter} download={this.downloadReport} showBody={this.showBody} />
                        {
                            this.state.showBody &&
                            <p className="text-right mt-2">
                                <i>Generated on : {moment().format('MMMM Do YYYY, h:mm:ss a')}</i>
                            </p>
                        }
                    </div>
                </div>
                <div id="patient-list-table">
                    {
                        this.state.showBody &&
                        <CardSimple>
                            <Body yearlyProfitReport={this.props.yearlyProfitReport} selectedyear={this.props.year} />

                            <Pagination
                                length={this.state.totalRow}
                                itemsPerPage={this.state.itemsPerPage}
                                activePage={this.state.activePage}
                                onPageChange={this.changePage}
                            />
                        </CardSimple>
                    }
                </div>
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        brachOptions: brachOptions,
        yearlyProfitReport: state.reports.yearlyProfitReport,
        loggedBranch: state.common.branchId,
        year: state.form.YearlyProfitReportYear,
        branch: state.form.YearlyProfitReportBranchOption
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getYearlyProfitReport: model => dispatch(getYearlyProfitReport(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(YearlyProfitReport));